/*
Design Philosophy: Neo-Industrial Editorial. The app shell must keep the experience dark, focused, and conversion-oriented, supporting the landing page's engineering-grade green palette, mint accents, and precise interaction language.
*/
import NotFound from "@/pages/NotFound";
import { lazy, Suspense } from "react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";

const Home = lazy(() => import("@/pages/Home"));
const StrategicVersion = lazy(() => import("./pages/StrategicVersion"));
const CommandRoomVersion = lazy(() => import("./pages/CommandRoomVersion"));
const DelayPlanningVersion = lazy(() => import("./pages/DelayPlanningVersion"));

function Router() {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path={"/"} component={Home} />
        <Route path={"/estrategico"} component={StrategicVersion} />
        <Route path={"/sala-de-controle"} component={CommandRoomVersion} />
        <Route path={"/obras-atrasam-sem-planejamento"} component={DelayPlanningVersion} />
        <Route path={"/404"} component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <Router />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
